export { default } from './PostImage';
